import {Injectable} from '@angular/core';
import {LocalStorage} from '@ngx-pwa/local-storage';

@Injectable()
export class ApiService {
  constructor(protected _ls: LocalStorage) {}
}
